export {default as SendTipScreen} from './SendTip/SendTipScreen';
export {default as TipsSettingsScreen} from './TipsSettings/TipsSettingsScreen';
